import React, { useContext, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import PageHeader from "../../../components/PageHeader";
import AllOrders from "./AllOrders";
import SelectPackage from "./SelectPackage";
import { ShippingRequestTracking } from "../../../components/PackageTracking";
import SidebarContext from "../../../context/SidebarContext";
import SimpleBar from "simplebar-react";
import OrderHistory from "../../../components/common/History/OrderHistory";
import OrderChats from "../../../components/common/orderChat/OrderChats";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveComponent,
  setActiveItem,
  setPackages,
  setRequests,
  setSelectedPackage,
  setSelectedRequest,
} from "../../../store/commonSlice";
import { useShippingRequestFilters } from "./hooks/useShippingRequestFilters";
import { useShippingRequestData } from "./hooks/useShippingRequestData";
import { useShippingRequestPackages } from "./hooks/useShippingRequestPackages";
import { formatDate } from "./utils/shippingRequestUtils";

const ShippingRequest = () => {
  const dispatch = useDispatch();
  const { selectedPackage: packageActiveData, activeComponent } = useSelector(
    (state) => state.common
  );
  const { open } = useContext(SidebarContext);

  // Use custom hooks
  const { selectedFilters, filterOptions, changeFilterHandler } =
    useShippingRequestFilters();
  const isLoading = useShippingRequestData(selectedFilters);
  useShippingRequestPackages();

  // Handlers
  const chatClickHandler = async (e, id, item) => {
    e.stopPropagation();
    dispatch(setActiveComponent("Chats"));
    dispatch(setSelectedPackage(item));
  };

  const historyClickHandler = async (id, item, e) => {
    e.stopPropagation();
    dispatch(setActiveComponent("History"));
    dispatch(setSelectedPackage(item));
  };

  const userClickHandler = async (id, item) => {
    dispatch(setActiveComponent("Actions"));
    dispatch(setSelectedRequest(item));
    dispatch(setSelectedPackage(null));
    dispatch(setActiveItem(null));
  };

  const packageClickHandler = async (id, item) => {
    dispatch(setActiveComponent("Actions"));
    dispatch(setSelectedPackage(item));
    dispatch(setActiveItem(null));
  };

  const closeHistoryHandler = () => {
    dispatch(setActiveComponent("Actions"));
  };

  // Steps configuration
  const steps = [
    {
      label: "Requested",
      date: packageActiveData?.packageShipmentCreationDate
        ? formatDate(packageActiveData.packageShipmentCreationDate)
        : "-",
    },
    {
      label: "Packing",
      date: packageActiveData?.preparedShipmentDate
        ? formatDate(packageActiveData.preparedShipmentDate)
        : "-",
    },
    {
      label: "Send",
      date: "-",
    },
    { label: "Done", date: "-" },
  ];

  const activeStep =
    packageActiveData?.packageStatus === "PREPARE_SHIPMENT_REQUEST_APPROVED"
      ? 2
      : 1;

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      dispatch(setSelectedPackage(null));
      dispatch(setSelectedRequest(null));
      dispatch(setRequests([]));
      dispatch(setPackages([]));
    };
  }, [dispatch]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "96vh",
        margin: "20px",
        marginRight: "0px",
        width: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
        // width: {
        //   xl: open === true ? "calc(98vw - 240px)" : "96vw",
        // },
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "12px",
      }}
    >
      <Box sx={{ borderBottom: "1px solid #E5E5E8" }}>
        <PageHeader pageTitle={"Single Shipping"} selectedFilters={selectedFilters} filterOptions={filterOptions} changeFilterHandler={changeFilterHandler} />
      </Box>
      <Box sx={{ flex: 1, backgroundColor: "white" }}>
        <Grid
          container
          spacing={0}
          sx={{
            width: open === false ? "calc(97vw - 80px)" : "calc(97vw - 240px)",
          }}
        >
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <AllOrders
              userClickHandler={userClickHandler}
              selectedFilters={selectedFilters}
              loading={isLoading}
            />
          </Grid> 
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={3}
            sx={{
              borderLeft: "1px solid #E5E5E8",
              borderRight: "1px solid #E5E5E8",
            }}
          >
            <SelectPackage
              packageClickHandler={packageClickHandler}
              historyClickHandler={historyClickHandler}
              chatClickHandler={chatClickHandler}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{
              borderLeft: "1px solid #E5E5E8",
              height: "86vh",
              // overflowY: "auto",
            }}
          >
            <SimpleBar
              forceVisible="y"
              autoHide={true}
              style={{
                maxHeight: "88vh",
                ".simplebar-scrollbar": {
                  background: "red",
                },
              }}
              className="custom-scrollbar"
            >
              {activeComponent === "Chats" && (
                <OrderChats
                  closeHistory={closeHistoryHandler}
                />
              )}
              {activeComponent === "History" && (
                <OrderHistory
                  closeHistory={closeHistoryHandler}
                />
              )}
              {activeComponent === "Actions" && (
                <ShippingRequestTracking
                  steps={steps}
                  activeStep={activeStep}
                />
              )}
              {/* <PackageSplit /> */}
            </SimpleBar>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ShippingRequest;
